import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const HEADER_OFFSET = 128

/**
 * Al cambiar de ruta: si hay #apartado, se desplaza hasta él dejando espacio
 * para la barra fija y lo resalta brevemente. Si no, vuelve arriba.
 */
export function useHashScroll() {
  const { pathname, hash, key } = useLocation()

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior })
      return
    }
    const id = decodeURIComponent(hash.slice(1))
    let tries = 0
    let retry = 0
    let clear = 0
    const attempt = () => {
      const el = document.getElementById(id)
      if (!el) {
        if (tries++ < 20) retry = window.setTimeout(attempt, 50)
        return
      }
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET
      window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' })
      el.classList.remove('guide-flash')
      void el.offsetWidth
      el.classList.add('guide-flash')
      clear = window.setTimeout(() => el.classList.remove('guide-flash'), 1900)
    }
    attempt()
    return () => {
      window.clearTimeout(retry)
      window.clearTimeout(clear)
    }
  }, [pathname, hash, key])
}
